<template>
    <div v-if="editor" :ref="refRichText" :class="classes">
        <CompassFormItem
            :label="formitem.label || ''"
            :info="formitem.info"
            :error="formitem.error || ''"
            :disabled="disabled"
            :required="formitem.required"
            :requiredLabel="formitem.requiredLabel"
            :size="formitem.size || 'medium'"
            :tooltip="formitem.tooltip || ''"
        >
            <RichTextBubbleMenu
                v-if="showAIComponents"
                :editorBubbleMenu="editor"
                :options="options"
                :typeRichText="typeRichText"
                :hash="hash"
            />

            <SellsyAILoadingDialog v-if="showAIComponents && showLoader" />

            <editor-content
                ref="editorContent"
                :class="editorClass"
                :editor="editor"
                :extensions="editorExtensions"
                :data-ref="refRichText"
                @focus="handleEditorFocus"
                @blur="handleEditorBlur"
            />

            <slot name="drag-handle"></slot>

            <!-- RichTextMenu (Menu with options) -->
            <RichTextMenu
                v-if="showRichTextMenu"
                :editorMenu="editor"
                :options="options"
                :typeRichText="typeRichText"
                :disabled="disabled"
                :hash="hash"
                :attachmentEndpoint="attachmentEndpoint"
            >
                <template #more-custom-options>
                    <slot name="more-custom-options"></slot>
                </template>
                <template #actions>
                    <slot name="actions"></slot>
                </template>
                <template #more-block>
                    <slot name="more-block"></slot>
                </template>
            </RichTextMenu>
        </CompassFormItem>
    </div>
</template>

<script>
import RichTextMixin from 'mixins/RichTextMixin';
import RichTextMenu from './RichTextMenu.vue';
import RichTextBubbleMenu from './RichTextBubbleMenu.vue';
import SellsyAILoadingDialog from 'vcomponents/richtext/SellsyAILoadingDialog.vue';
import { editorClass } from 'Helpers/richTextHelper.js';

export default {
    name: 'RichText',
    components: {
        RichTextMenu,
        RichTextBubbleMenu,
        SellsyAILoadingDialog,
    },
    mixins: [RichTextMixin],
    provide() {
        return {
            parentHash: this.hash,
            refRichText: this.refRichText,
        };
    },
    props: {
        modelValue: {
            type: String,
            default: '',
        },
        refRichText: {
            type: String,
            default: '',
        },
        formitem: {
            type: Object,
            default: () => ({}),
        },
        isCustom: {
            type: Boolean,
            default: false,
        },
        showRichTextMenu: {
            type: Boolean,
            default: true,
        },
        showAIComponents: {
            type: Boolean,
            default: false,
        },
        typeRichText: {
            type: String,
            default: '',
        },
        hash: {
            type: String,
            default: '',
        },
        attachmentEndpoint: {
            type: String,
            default: '',
        },
    },
    emits: ['focus', 'blur'],
    data() {
        return {
            isFocus: false,
        };
    },
    computed: {
        /* custom class */
        classes() {
            return [
                { 'rich-text': !this.isCustom },
                { 'is-disabled': this.disabled },
                { 'is-focus': this.isFocus },
                { 'is-error': this.formitem.error && !this.disabled },
            ];
        },
        getHash() {
            return `ai-${this.hash}`;
        },
        showLoader() {
            return this.$store.state[this.getHash]?.showLoader || false;
        },
        editorClass,
    },
    watch: {
        modelValue(value) {
            const isSame = this.editor.getHTML() === value;
            if (isSame) {
                return;
            }
            this.editor.commands.setContent(value, false);
        },
        isFocus(value) {
            if (value) {
                this.$emit('focus');
            } else {
                this.$emit('blur');
            }
        },
    },
    methods: {
        handleEditorFocus() {
            this.isFocus = true;
        },
        handleEditorBlur() {
            this.isFocus = false;
        },
        // eslint-disable-next-line vue/no-unused-properties
        focus() {
            this.$refs.editorContent?.editor.commands.focus();
        },
    },
};
</script>
